import React from 'react';
import { Title } from '../../atoms';

export const PrintItemsList = ({
    quantity,
}) => {
    return (
        <div className="listContainer">
            <div className="qAlign">
                <Title text={quantity} className="printProductCls" />
            </div>
        </div>
    )
}
